import React from "react";
import SystemGeneratorPage from "./SystemGeneratorPage";
import "./RestaurantSystemsPage.css";

function RestaurantSystemsPage({ business = null }) {
  return (
    <div className="restaurant-simple">
      <section className="restaurant-simple__intro">
        <div className="restaurant-simple__badge">Restaurant storefront</div>
        <h2>Describe your menu in plain English</h2>
        <p>
          Keep it short. Mention cuisine, service type, hours, and a few signature items.
          We’ll generate a storefront you can publish in minutes.
        </p>
        <div className="restaurant-simple__example">
          <p>Example</p>
          <pre>
            {`Modern Italian trattoria. Dine-in + takeaway. Open Tue-Sun 12:00-22:00.
Signature items: truffle pasta, burrata salad, wood-fired margherita, tiramisu.
Offer pickup and delivery within 3 miles. Average spend £18-25.`}
          </pre>
        </div>
      </section>
      <SystemGeneratorPage business={business} systemTypeOverride="restaurant" />
    </div>
  );
}

export default RestaurantSystemsPage;
